// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__XqI46","loginBox":"SignUp_loginBox__lvvZo","body":"SignUp_body__9Tj6d"};